import { SvgIcon, SvgIconProps } from "@mui/material";

const ReportsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
<path d="M7.5 4C6.675 4 6.0075 4.72 6.0075 5.6L6 18.4C6 19.28 6.6675 20 7.4925 20H16.5C17.325 20 18 19.28 18 18.4V9.464C18 9.04 17.8425 8.632 17.5575 8.336L13.935 4.472C13.6575 4.168 13.275 4 12.8775 4H7.5ZM12.75 8.8V5.2L16.875 9.6H13.5C13.0875 9.6 12.75 9.24 12.75 8.8Z" fill="currentColor"/>
</SvgIcon>
);

export default ReportsIcon;
